const relatedQueriesImpression = (data) => ({
  tracker: 'trackSelfDescribingEvent',
  data: {
    schema: 'iglu:org.ecosia/result_impression_event/jsonschema/2-0-1',
    data: {
      query: data.query,
      vertical: 'web',
      impressions: data.impressions,
      page_position: data.page_position,
    },
  },
  context: ['mainCookie', 'abTests', 'requestID'],
});

export default relatedQueriesImpression;
